import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import logger from "@insite/client-framework/Logger";
import { getProductCollectionRealTimePrices } from "@insite/client-framework/Services/ProductServiceV2";
import { chain, RequestDataFromApi } from "@insite/client-framework/Store/CommonHandlers/LoadRealTimePricing";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";

type HandlerType = Parameters<typeof RequestDataFromApi>[0];

async function AuerRequestDataFromApi(props: HandlerType) {
    logger.debug(props.getState());
    if (!getSettingsCollection(props.getState()).productSettings.canSeePrices) {
        return false;
    }

    try {
        props.apiResult = await getProductCollectionRealTimePrices(props.apiParameter);
    } catch (error) {
        if (error.status === 403) {
            // auth timed out with sign in required for pricing - throw this up as a 401 so DisplayError reloads the site
            error.status = 401;
            error.errorJson = { message: "error" };
            throw error;
        } else {
            logger.warn(`Failed to load pricing data: ${error}`);
            props.error = error;
        }
    }
}

replaceInChain(chain, RequestDataFromApi, AuerRequestDataFromApi)